<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text animate-target" v-animate-in>Irrespective of baseline SGLT-2i use<sup>1,2</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-10/3-10-1.png" />
    <div class="ctn-text animate-target" v-animate-in>Irrespective of baseline GLP-1RA use<sup>3</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-10/3-10-2.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-11">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-10",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*CV death, non fatal MI, non fatal stroke or HHF;<br/>"
      +"<sup>#</sup>kidney failure (ESKD or eGFR <15 ml/min/1.73 m2), sustained ≥57% decrease in eGFR from baseline for ≥4 weeks, or renal death.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Rossing P, <i>et al. Diabetes Care</i> 2022;45:2991–2998;<br/>"
      +"2. Agarwal R, <i>et al. Eur Heart J</i> 2022;43:474–484.<br/>"
      +"3. Rossing P, <i>et al. Diabetes Obes Metab</i> 2023;25:407–416",
      title:"Finerenone reduced the risk of the CV and kidney composite outcome"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-text {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top: 40px;
}
.ctn-image {
  width: 100%;
  margin-top: 30px;
}
</style>
